<div class="mat-toolbar top-header" [ngClass]="{ 'login-header': !isLoggedInUser }">
  <div class="row no-margin p-0">
    <div class="col-2 text-center no-margin p-0">
      <img class="dhl-logo" src="assets/images/bbx-logo.png" alt="Logo" />
    </div>

    <div class="col-2 text-start no-margin p-0">
      <span *ngIf="environmentConfig.TITLE !== 'MYDHL BREAKBULK PROD'" class="environment-warning">
        {{'header.testMode' | translate}}</span
      >
    </div>

    <div class="col-xl-3 col-sm-3 col-lg-3 col-md-3 text-end no-margin p-0">
      <span *ngIf="isLoggedInUser && isUserCanViewCustomers()">
        <mat-form-field style="font-size: 4px" appearance="none">
          <mat-select
            disableRipple
            [(ngModel)]="selectedCustomerID"
            class="form-control"
            (openedChange)="triggerEvent($event)"
            (selectionChange)="changeCustomerID()">
            <div class="p-2 search-bar-group">
              <input
                matInput
                class="pt-2 input-search"
                [(ngModel)]="searchTermCustomers"
                (keyup)="filterBySearch(this.searchTermCustomers)"
                placeholder="{{'header.searchCustomer' | translate}}" />
            </div>
            <div class="scrollable-div">
              <mat-option *ngFor="let eachId of customerIDs | sortBy : ''" [value]="eachId">
                {{ eachId }}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </span>
    </div>

    <div class="col-xl-3 col-sm-3 col-lg-3 col-md-3 no-margin role-select">
      <span *ngIf="isLoggedInUser">
        <mat-form-field style="font-size: 4px" appearance="none">
          <mat-select
            disableRipple
            [(ngModel)]="selectedRole"
            class="form-control"
            (selectionChange)="changeRole()">
            <mat-option *ngFor="let option of Roles" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>


    <div class="col-xl-1 col-sm-1 col-lg-1 col-md-1 text-end no-margin p-0">
      <button mat-icon-button [matMenuTriggerFor]="menuLanguage">
        <i class="icon-mat bi bi-translate"></i>
      </button>

      <mat-menu #menuLanguage="matMenu">
        <ng-container *ngTemplateOutlet="langTemplate"></ng-container>
      </mat-menu>

      <ng-template #langTemplate>
        <button mat-menu-item (click)="switchLanguage('en')">
          <span>English</span>
        </button>
        <button mat-menu-item (click)="switchLanguage('zh')">
          <span>中文</span>
        </button>
        <button mat-menu-item (click)="switchLanguage('es')">
          <span>español</span>
        </button>
        
      </ng-template>
    </div>

    <div class="col-xl-1 col-sm-1 col-lg-1 col-md-1 text-end no-margin p-0">
      <span *ngIf="isLoggedInUser">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <img class="account" src="assets/images/account.png" alt="Account" />
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item disabled>
            <i class="mt-3 icon-mat bi bi-person"></i>
            <span>{{ bbxuserID }}</span>
          </button>

          <button mat-menu-item (click)="usersList()" *ngIf="bbxuserrole != 'OPS_USER'">
            <i class="icon-mat bi bi-people"></i>
            <span>{{'header.usersList' | translate}}</span>
          </button>
          <a
            [href]="profileUrl"
            style="color: inherit; text-decoration: none"
            target="_blank"
            rel="noopener noreferrer">
            <button mat-menu-item>
              <i class="icon-mat bi bi-key"></i>
              <span>{{'header.profile' | translate}}</span>
            </button>
          </a>

          <button mat-menu-item (click)="logoutUser()">
            <i class="icon-mat bi bi-box-arrow-right"></i>
            <span>{{'header.logout' | translate}}</span>
          </button>
        </mat-menu>
      </span>
    </div>
  </div>
</div>

<div class="login-menu" *ngIf="!isLoggedInUser">.</div>
<app-menubar *ngIf="isLoggedInUser"></app-menubar>
